import Mixin from "../mixin.js";
import Utils from "../services/utils-service.js";
import Funnel from "../services/funnel-service.js";
import { throwError } from "../errors.js";

import Label from "./utils/Label.js";
import { watch } from "vue";

const template = `
<div v-show="isVisible(input)" id="consent-style">
    <div class="grid ">
        <div class="alert rounded no-icon s12 clm" :class="input.class" v-if="input.inline">
            <div v-for="ctuid in consentUids()">
                <div class="grid collapse">
                    <div class="s12 clm" v-if="elem(ctuid).title">
                        <span class="consent-title" v-html="parseHtml(elem(ctuid).title)"></span>
                    </div>
                    <div class="s12 clm consent-container" v-for="(item, index) in elem(ctuid).options" :uid="elem(ctuid).uid" v-show="fs.display(item)">
                        <input type="checkbox"
                        class="inline"
                        :uid="elem(ctuid).uid"
                        :id="elem(ctuid).id"
                        :required="elem(ctuid).validation?.required"
                        :name="elem(ctuid).element_name"
                        :checked="setChecked(item, ctuid)"
                        @keydown.enter.prevent="handleEnter(elem(ctuid))"
                        @change="processConsent(ctuid, $event.target.value, $event.target.checked)"
                        :disabled="setDisabled(item.disabled)"
                        :value="item.value"
                        v-bind="validationRules(ctuid)"
                        :data-uid="elem(ctuid).uid"
                        :aria-required="elem(ctuid).validation?.required"
                        :aria-labelledby="'label_'+elem(ctuid).uid"
                        :ref="elem(ctuid).element_name"
                        />
                        <qt-label :iuid="elem(ctuid).uid" />
                    </div>
                    <div class="error-here"></div>
                </div>
            </div>
        </div>
        <div class="alert rounded no-icon s12 clm" :class="input.class" v-else>
            <div v-for="ctuid in consentUids()">
                <!--img :src="fs.icon(elem(ctuid))" class="icon iconic center" /-->
                <p class="card-toggle-question" :class="elem(ctuid).helpText ? 'tooltip':''" :title="elem(ctuid).helpText" v-html="elem(ctuid).label"></p>
                <div class="grid collapse">
                    <div class="s12 clm" v-if="input.title">
                        <span class="consent-title" v-html="parseHtml(input.title)"></span>
                    </div>
                    
                    <div class="s12 m3 clm bool-radio" v-for="(item, index) in elem(ctuid).options" :uid="elem(ctuid).uid" v-show="fs.display(item)">
                            <input type="checkbox"
                            :uid="elem(ctuid).uid"
                            :id="computedCheckboxId(elem(ctuid).id, index)"
                            :required="elem(ctuid).validation?.required"
                            :name="elem(ctuid).element_name"
                            :checked="setChecked(item, ctuid)"
                            @keydown.enter.prevent="handleEnter(elem(ctuid))"
                            @change="processConsent(ctuid, $event.target.value, $event.target.checked)"
                            :disabled="setDisabled(item.disabled)"
                            :value="item.value"
                            v-bind="validationRules(ctuid)"
                            :data-uid="elem(ctuid).uid"
                            aria-labelledby="'label_'+computedCheckboxId(elem(ctuid).id, index)"
                            :ref="computedCheckboxId(elem(ctuid).id, index)"
                            />
                            <qt-label :iuid="elem(ctuid).uid" :item='item' :item_index="index" :format="'custom'"></qt-label>
                    </div>
                    <div class="error-here"></div>
                </div>
            </div>
        </div>
    </div>
</div>
`;


export default {
    name: 'b-consent',
    template,
    props: ['iuid'],
    mixins: [Mixin],

    components: {
        'qt-label': Label
    },
    mounted: function () {
        var self = this;
        this.$nextTick(function () {
            const cuids = self.consentUids();
            for (const uid of cuids) {
                const res = self.determineStatusOfConsentElementInContext(uid);
                self.processConsent(uid, res.value, res.checked, false);
            }
        });
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel'
        ]),
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        items: function () {
            return { ... this.input.options };
        },
        radio_count: function () {
            var count = 0;
            var options = this.input.options
            if (options) {
                options.forEach(function (option) {
                    count++;
                });
            }
            if (count === 2) {
                var offset = 'clm m6  m-offset-3'
            } else if (count === 3) {
                var offset = 'clm m6 m-offset-3'
            } else if (count === 4) {
                var offset = 'clm m8 m-offset-2'
            } else if (count === 5) {
                var offset = 'clm m10 m-offset-1'
            }
            return offset;
        },
        gridClass: function () {
            return 'block-grid-l5'
        },

    },
    methods: {
        computedCheckboxId(uid, item_index) {
            console.log(uid + '_option_' + item_index);
            return uid + '_option_' + item_index
        },
        elem(iuid) {
            return this.$store.getters.funnel.elements[iuid];
        },
        validationRules(ctuid) {
            if (!Utils.isObjEmpty(this.elem(ctuid)))
                return this.elem(ctuid).validation;
        },

        consentUids() {
            let ctUids = [this.input.uid];
            if (!Utils.isObjEmpty(this.input.additional_consent))
                ctUids = [...ctUids, ...this.input.additional_consent];
            return ctUids;
        },

        getBrandConsentUids() {
            const adUids = this.elem('in_consent').additional_consent;
            return adUids.filter(cuid => cuid.includes('in_consent_brand_'));
        },

        processConsent(ctuid, val, checked, setCC = true) {
            const elem = this.elem(ctuid);

            let option = [];
            for (const opt of elem.options) {
                if (opt.value == val) {
                    option = opt;
                }
            }
            if (!Utils.isObjEmpty(option)) {
                try {
                    eval(`this.${option.action}(ctuid, option, checked, setCC)`);
                } catch (err) {
                    let eMsg = `Error:- eventHandler: ${err}. calling non-existent function.`;
                    console.error(eMsg);
                    throwError(new Error(eMsg), { "option": option, "ctuid": ctuid, "input": JSON.stringify(elem) });
                }
            }
        },

        accept(ctuid, opt, checked, setCC = true) {
            console.log('Consent uid:', ctuid);
            const elem = this.elem(ctuid);
            let elems = {};
            let cc = elem.contact_channels;

            console.log('Accepted checked:', checked);

            if (setCC)
                elems[elem.uid] = checked ? cc : ['no'];

            console.log('Accepted value:', elems[elem.uid]);

            this.copyParentConsentToBrands(elem, checked);

            if (elem.consent_type == 'mapped_to_channel') {
                const val = checked ? opt.value : 'no';
                this.mapConsentToChannels(elem, val);
            }

            this.updateConsent(elems);

            this.mapBrandConsentToChannels(elem);

            // :indeterminate to partially selected 
            this.multicheckUI(elem);
        },
        multicheckUI(elem) {
            if (elem.consent_type == 'parent_util' || elem.consent_type == 'brand') {
                const acUids = this.getBrandConsentUids();
                let totalBrands = acUids.length;
                let checkedBrands = [];

                acUids.forEach((a_c) => {
                    if (!checkedBrands.includes(a_c) && (this.funnel.elements[a_c].value[0] != 'no' && this.funnel.elements[a_c].value.length != 0)) {
                        checkedBrands.push(a_c)
                    }
                });

                if (checkedBrands.length != totalBrands && checkedBrands.length != 0) {
                    this.$refs['in_consent'][0].indeterminate = true;
                }
                else {
                    this.$refs['in_consent'][0].indeterminate = false;
                }

                if (checkedBrands.length == totalBrands) {
                    // instead of just setting check , trigger click to process as the accept. -G
                    if (!this.$refs['in_consent'][0].checked) {
                        this.$refs['in_consent'][0].click()
                    }

                }
                if (checkedBrands.length == 0) {
                    this.$refs['in_consent'][0].checked = false;
                }
            }
        },
        copyParentConsentToBrands(elem, checked) {
            if (elem.consent_type == 'parent_util') {
                const acUids = this.getBrandConsentUids();
                for (const uid of acUids) {
                    let cval = checked ? [this.elem(uid)['options'][0].value] : ['no'];
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: cval });
                }
            }
        },

        mapConsentToChannels(elem, val) {
            if (!Utils.isObjEmpty(elem)) {
                let elements = {};
                for (const channel of elem.contact_channels) {
                    elements[`in_${channel}_consent`] = val;
                    elements[`in_${channel}_consent_version`] = elem.channels_map[channel].version;
                }
                this.updateConsent(elements);
            }
        },

        mapBrandConsentToChannels(elem) {
            if (elem.consent_type == 'parent_util' || elem.consent_type == 'brand') {
                const status = this.checkIfBrandConsent();
                const element = this.elem('in_consent');
                this.mapConsentToChannels(element, status.channel_value);
            }
        },

        checkIfBrandConsent() {
            let status = { channel_value: 'no', c_ctx: {} };
            const acUids = this.getBrandConsentUids();
            for (const uid of acUids) {
                status['c_ctx'] = this.determineStatusOfConsentElementInContext(uid);
                if (!Utils.isObjEmpty(status.c_ctx) && status.c_ctx.checked) {
                    status['channel_value'] = status.c_ctx.value[0];
                    break;
                }
            }
            return status;
        },

        determineStatusOfConsentElementInContext(uid) {
            let res = { value: {}, checked: false };
            const elem = this.elem(uid);
            const options = elem.options;
            const val = res['value'] = elem.value;
            if (typeof val == 'object' && !Utils.isObjEmpty(val) && val.length >= 1) {
                if (
                    !Utils.isObjEmpty(options) &&
                    (options[0].value == val[0] || Utils.compareArrays(val, elem.contact_channels))
                ) {
                    res['value'] = [options[0].value];
                    res['checked'] = true;
                }
            }
            return res;
        },

        updateConsent(elems) {
            for (const uid in elems) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: elems[uid] });
            }
        },

        setChecked(item, ctuid) {
            console.log('setchecked');
            var checked = false;
            if (!Utils.isEmpty(this.elem(ctuid).value)) {
                checked = this.elem(ctuid).value.indexOf(item.value) > -1;
            }
            return checked;
        },
        handleEnter(item) {
            $('#' + item.id).click()
        }
    }
};
